class SocialFeed extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {


        const carouselContainer = this.querySelector('.swiper');

        if (!carouselContainer) return;

        const initializeCarousel = () => {

          whenReady("Swiper", () => {
            const mediaSwiper = new Swiper(carouselContainer, {
                a11y: true,
                loop: true,
                slidesPerView: "auto",
                centeredSlides: true,
                spaceBetween: 16,
                mousewheel: {
                    enabled: true,
                    forceToAxis: true
                },
                freeMode: true,
                pagination: {
                  el: this.querySelector(".swiper-pagination"),
                  clickable: true
                }
  
            });
          })


        };

        initializeCarousel();

    }
  
  }
  
  if (!window.customElements.get("social-feed")) {
    customElements.define("social-feed", SocialFeed);
  }